export const SET_ADMIN_TOOLBOX = 'SET_ADMIN_TOOLBOX'
export const SET_MANAGER_TOOLBOX = 'SET_MANAGER_TOOLBOX'
export const SET_EMPLOYEE_TOOLBOX = 'SET_EMPLOYEE_TOOLBOX'
export const SET_LATEST_TOOLBOX = 'SET_LATEST_TOOLBOX'
export const REFETCH_TOOLBOXES = 'REFETCH_TOOLBOXES'

export const SET_ADMIN_LAYOUTS = 'SET_ADMIN_LAYOUTS'
export const SET_MANAGER_LAYOUTS = 'SET_MANAGER_LAYOUTS'
export const SET_EMPLOYEE_LAYOUTS = 'SET_EMPLOYEE_LAYOUTS'
